// extracted by mini-css-extract-plugin
export var root = "Features-module--root--3cS4j";
export var box = "Features-module--box--11Kdo";
export var col = "Features-module--col--1f8jC";